/* eslint-disable jsx-a11y/anchor-is-valid */
import { Alert, Grid } from '@mui/material';
import React from 'react';
import { useParams } from 'react-router-dom';

import LineItemForm from '../components/LineItems/LineItemForm';
import LineItemSkeleton from '../components/LineItems/LineItemSkeleton';
import useLineItem from '../hooks/useLineItem';

function LineItemPage() {
  const params = useParams();
  const { isLoading, isError, data } = useLineItem(Number(params.lineItemId));

  if (isLoading) {
    return <LineItemSkeleton />;
  }

  // A missing/deleted line item (bad id in the URL) comes back with no id once mapped,
  // and a failed fetch sets isError. Either way, render a not-found alert instead of
  // mounting the form on empty data — that otherwise cascades into render crashes across
  // the child field components (contractId.toString(), optimizationTypeIds.includes(), ...).
  if (isError || !data?.lineItemId) {
    return (
      <Grid container>
        <Grid item xs={12}>
          <Alert severity="error">Line item not found</Alert>
        </Grid>
      </Grid>
    );
  }

  return <LineItemForm lineItemData={data} isNewLineItem={false} />;
}

export default LineItemPage;
